import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { AtividadeEconomica } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class IbgeService {

  constructor(private readonly http: McticHttpClient) {
  }

  obterAtividadePorId(id: number) {
    return this.http.get<AtividadeEconomica>(`/sepin-backend/rest/proxy/ibge/cnae/atividade/${id}`);
  }

  obterTodasAtividadesEconomicasPorNome(nome: string): Observable<AtividadeEconomica[]> {
      return this.http.get<AtividadeEconomica[]>(`/sepin-backend/rest/proxy/ibge/cnae/atividade/nome/${nome}`);
  }

  obterTodasAtividadesEconomicasPorCodigo(codigo: string): Observable<AtividadeEconomica[]> {
      return this.http.get<AtividadeEconomica[]>(`/sepin-backend/rest/proxy/ibge/cnae/atividade/codigo/${codigo}`);
  }

}
